import { StateCreator } from 'zustand';

type AuthLoadingStatus =
    | 'not-loading'
    | 'login-loading'
    | 'login-loading-with-cart-modifications'
    | 'logout-loading'
    | 'registration-loading'
    | 'registration-loading-with-cart-modifications';

export type AuthLoadingSlice = {
    authLoading: AuthLoadingStatus;

    updateAuthLoadingState: (value: AuthLoadingStatus) => void;
};

export const createAuthLoadingSlice: StateCreator<AuthLoadingSlice> = (set) => ({
    authLoading: 'not-loading',

    updateAuthLoadingState: (value) => {
        set({ authLoading: value });
    },
});
